/* NX1 PROJECT | Glaze | cart drawer on the Shopify Ajax Cart API. No dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('[data-nx-cart]');
  if (!root) return;
  var cfg = JSON.parse(root.querySelector('[data-nx-cart-config]').textContent);
  var body = root.querySelector('[data-nx-cart-body]');
  var foot = root.querySelector('[data-nx-cart-foot]');
  var ship = root.querySelector('[data-nx-cart-ship]');
  var errorEl = root.querySelector('[data-nx-cart-error]');
  var cart = null;
  var MIN_QTY = (cfg.upsellMinQty) || 3; // main product quantity needed to offer the upsell
  var DEFAULT_MIN_QTY = (cfg.upsellDefaultMinQty != null) ? cfg.upsellDefaultMinQty : 1;
  var upsell = null;      
  var upsellCache = {};   
    var lastFocus = null;
  function fetchUpsell(handle) {
    if (handle in upsellCache) return Promise.resolve(upsellCache[handle]);
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'products/' + encodeURIComponent(handle))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var j = null;
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-nx-upsell-json]');
          if (el) j = JSON.parse(el.textContent);
        } catch (e) {}
        upsellCache[handle] = j || false;
        return upsellCache[handle];
      })
      .catch(function () { upsellCache[handle] = false; return false; });
  }

function parentQuantities(c) {
  var byHandle = {};
  var total = 0;
  c.items.forEach(function (it) {
    if (it.properties && it.properties._upsell_for) return; // skip upsell lines
    byHandle[it.handle] = (byHandle[it.handle] || 0) + it.quantity;
    total += it.quantity;
  });
  return { byHandle: byHandle, total: total };
}

function resolveUpsell() {
  var q = parentQuantities(cart);
  var handles = Object.keys(q.byHandle).filter(function (h) {
    return q.byHandle[h] >= MIN_QTY;
  });
  var inCart = cart.items.map(function (it) { return Number(it.variant_id); });

  return Promise.all(handles.map(fetchUpsell)).then(function (list) {
    // 1) metafield upsell from a product that has enough quantity
    for (var i = 0; i < list.length; i++) {
      if (list[i] && inCart.indexOf(Number(list[i].id)) === -1) {
        return Object.assign({}, list[i], { source: handles[i] });
      }
    }
    // 2) fallback upsell from config, needs enough total quantity of main products
   if (cfg.upsell && q.total >= DEFAULT_MIN_QTY && inCart.indexOf(Number(cfg.upsell.id)) === -1) {
      return Object.assign({}, cfg.upsell, { source: '*' });
    }
    return null;
  });
}
function findOrphans(c) {
  var q = parentQuantities(c);
  var orphans = [];
  c.items.forEach(function (it) {
    var src = it.properties && it.properties._upsell_for;
    if (!src) return;
    var isDefault = src === '*';
    var qty = isDefault ? q.total : (q.byHandle[src] || 0);
    var min = isDefault ? DEFAULT_MIN_QTY : MIN_QTY;
    if (qty < min) orphans.push(it.key);
  });
  return orphans;
}

function setCart(c) {
  var orphans = findOrphans(c);
  if (orphans.length) {
    var updates = {};
    orphans.forEach(function (k) { updates[k] = 0; });
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return postJson(base + 'cart/update.js', { updates: updates })
      .then(setCart)
      .catch(function () { cart = c; return resolveUpsell().then(function (u) { upsell = u; render(); }); });
  }
  cart = c;
  return resolveUpsell().then(function (u) { upsell = u; render(); });
}
// function setCart(c) {
//   cart = c;
//   return resolveUpsell().then(function (u) { upsell = u; render(); });
// }
  function money(cents) {
    var cur = (cart && cart.currency) || cfg.currency || 'GBP';
    try { return new Intl.NumberFormat(cfg.locale || 'en-GB', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function request(url, opts) {
    opts = opts || {};
    opts.headers = opts.headers || {};
    opts.headers.Accept = 'application/json';
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }
  function postJson(url, data) {
    return request(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
  }
  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg || '';
    errorEl.hidden = !msg;
  }

  function updateCounts() {
    var count = cart ? cart.item_count : 0;
    document.querySelectorAll('[data-nx-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-nx-cart-dot]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    var hc = root.querySelector('[data-nx-cart-heading-count]');
    if (hc) hc.textContent = count ? '(' + count + ')' : '';
  }

  function lineHtml(it) {
    var props = '';
    if (it.properties) {
      Object.keys(it.properties).forEach(function (k) {
        var v = it.properties[k];
        if (k.charAt(0) === '_' || v === '' || v == null) return;
        props += '<p class="nx-cart__variant">' + esc(k) + ': ' + esc(v) + '</p>';
      });
    }
    var image = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
    var upFor = it.properties && it.properties._upsell_for;
    var isUpsell = !!(upFor && upFor !== '*'); // metafield upsell only
    var qtyHtml = isUpsell
      ? '<span class="nx-cart__qty-fixed">Qty: ' + it.quantity + '</span>'
      : '<div class="nx-qty"><button type="button" data-step="-1" aria-label="Reduce quantity of ' + esc(it.product_title) + '">&minus;</button><output aria-live="polite">' + it.quantity + '</output><button type="button" data-step="1" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div>';
    return '<li class="nx-cart__line' + (isUpsell ? ' nx-cart__line--upsell' : '') + '" data-key="' + esc(it.key) + '" data-qty-now="' + it.quantity + '">' +
      '<a class="nx-cart__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (image ? '<img src="' + esc(sized(image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div>' +
        '<a class="nx-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (it.product_has_only_default_variant ? '' : '<p class="nx-cart__variant">' + esc(it.variant_title) + '</p>') +
        props +
        '<div class="nx-cart__controls">' +
        qtyHtml +
        '<button type="button" class="nx-cart__remove" data-remove>' + esc(cfg.removeLabel) + '</button>' +
      '</div>' +
      '</div>' +
      '<div class="nx-cart__price">' + money(it.final_line_price) + (it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '') + '</div>' +
    '</li>';
  }

  function render() {
    updateCounts();
    var count = cart.item_count;
    if (ship) {
      var t = cfg.freeThreshold, total = cart.total_price;
      if (!t || !count) { ship.hidden = true; }
      else {
        ship.hidden = false;
        var left = t - total;
        ship.querySelector('p').textContent = left > 0 ? cfg.freeAway.replace('[amount]', money(left)) : cfg.freeDone;
        ship.querySelector('.nx-cart__bar span').style.width = (Math.min(total / t, 1) * 100) + '%';
      }
    }
    if (!count) {
      body.innerHTML = '<div class="nx-cart__empty"><p>' + esc(cfg.emptyText) + '</p>' + (cfg.emptyButton ? '<a href="' + esc(cfg.emptyLink) + '" class="nx-btn nx-btn--dark">' + esc(cfg.emptyButton) + '</a>' : '') + '</div>';
      foot.hidden = true;
      return;
    }
       var html = '<ul class="nx-cart__lines">' + cart.items.map(lineHtml).join('') + '</ul>';
       var up = upsell;
      if (up) {
            html += '<div class="nx-cart__upsell"><h3>' + esc(cfg.upsellHeading) + '</h3><div class="nx-cart__up">' +
              '<a class="nx-cart__img" href="' + esc(up.url) + '" tabindex="-1" aria-hidden="true">' + (up.image ? '<img src="' + esc(up.image) + '" alt="" loading="lazy">' : '') + '</a>' +
              '<div><a class="nx-cart__name" href="' + esc(up.url) + '">' + esc(up.title) + '</a><small>' + money(up.price) + '</small></div>' +
              '<button type="button" data-upsell="' + up.id + '">' + esc(cfg.upsellButton) + '</button>' +
            '</div></div>';
          }
          body.innerHTML = html;
          foot.hidden = false;
          root.querySelector('[data-nx-cart-subtotal]').textContent = money(cart.total_price);
        }

  function busy(on) { root.classList.toggle('is-busy', !!on); }
   function load() {
  return request(cfg.cartJs).then(setCart);
    }
    function change(key, qty) {
      busy(true); showError('');
      return postJson(cfg.change, { id: key, quantity: qty })
        .then(setCart)
        .catch(function (err) { showError(err.message); return load(); })
        .then(function () { busy(false); });
    }   
  function add(items) {
    busy(true); showError('');
    return postJson(cfg.add, { items: items })
      .then(load)
      .catch(function (err) { showError(err.message); return load(); })
      .then(function () { busy(false); });
  }

  function open(refresh) {
    lastFocus = document.activeElement;
    document.querySelectorAll('details.nx-drawer[open]').forEach(function (d) { d.removeAttribute('open'); });
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nx-lock');
    var ready = (refresh || !cart) ? load() : Promise.resolve();
    ready.then(function () { var c = root.querySelector('.nx-cart__close'); if (c) c.focus(); });
    return ready;
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nx-lock');
    showError('');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-nx-cart-open]');
    if (opener) { e.preventDefault(); open(true); return; }
    if (e.target.closest('[data-nx-cart-close]')) { e.preventDefault(); close(); return; }
    if (!root.contains(e.target)) return;
    var line = e.target.closest('[data-key]');
    var step = e.target.closest('[data-step]');
    if (line && step) { change(line.dataset.key, Math.max(0, parseInt(line.dataset.qtyNow, 10) + parseInt(step.dataset.step, 10))); return; }
    if (line && e.target.closest('[data-remove]')) { change(line.dataset.key, 0); return; }
    var upBtn = e.target.closest('[data-upsell]');
      if (upBtn) {
        add([{
          id: parseInt(upBtn.dataset.upsell, 10),
          quantity: 1,
          properties: { _upsell_for: (upsell && upsell.source) || '*' }
        }]);
      }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  /* Plain add-to-cart forms (product cards and similar) open the drawer instead of loading the cart page. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (f.hasAttribute('data-nx-product-form') || f.hasAttribute('data-nx-no-drawer')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    request(cfg.add, { method: 'POST', body: new FormData(f) })
      .then(function () { return open(true); })
      .catch(function (err) { return open(true).then(function () { showError(err.message); }); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  window.NX1Cart = { open: open, close: close, refresh: load, showError: showError };
})();